import { Box, Typography } from "@mui/material";

import { FormSubSection } from "@/components/FormEngine/types";

import { BaseRendererProps } from "../../types";
import { RowRenderer } from "../RowRenderer";

interface SubSectionRendererProps extends BaseRendererProps {
  subSection: FormSubSection;
  subSectionIndex: number;
  fieldsMap?: Record<string, any>; // NEW
}

export const SubSectionRenderer: React.FC<SubSectionRendererProps> = ({
  subSection,
  subSectionIndex,
  formState,
  onFieldChange,
  fieldsMap, // NEW
}) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant='title3' gutterBottom>
      Sous-section {subSectionIndex}
    </Typography>

    {subSection.rows.map((row) => (
      <RowRenderer
        key={row.id}
        row={row}
        formState={formState}
        onFieldChange={onFieldChange}
        fieldsMap={fieldsMap} // NEW
      />
    ))}
  </Box>
);
